<script lang="ts">
import PhxsgRichText, {
  PhxsgRichTextProps as PhxsgCoreRichTextProps,
} from '@sg-core/src/View/Components/Atoms/RichText/phxsg-rich-text.vue';

export interface PhxsgRichTextProps extends PhxsgCoreRichTextProps {
  spacing?: number;
  headingCap?: '' | 'h4';
  centered?: boolean;
}
</script>

<script setup lang="ts">
const { spacing = 0, centered = false, headingCap = '', html = undefined } = defineProps<PhxsgRichTextProps>();
</script>

<template>
  <PhxsgRichText
    :html="html"
    :centered="centered"
    :class="[
      {
        [`phxsg-rich-text--spacing-${spacing}`]: typeof spacing === 'number',
        [`phxsg-rich-text--cap-${headingCap}`]: !!headingCap,
      },
    ]"
  >
    <slot />
  </PhxsgRichText>
</template>

<style src="./rich-text.css" />
